//i18n-setup.js
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import deFormal from './lang/de_DE_formal.json'
import deInformal from './lang/de_DE_informal.json'
import en from './lang/en_US.json'
import enGB from './lang/en_GB.json'
import enCA from './lang/en_CA.json'
import frCA from './lang/fr_CA.json'
import deAT from './lang/de_AT.json'
// import lbLU from './lang/lb_LU.json'
import deLU from './lang/de_LU.json'
import frLU from './lang/fr_LU.json'
import enDE from './lang/en_DE.json'
import deCH from './lang/de_CH.json'


Vue.use(VueI18n)
const messages = {
    // frontend workaround because i18n somehow can't handle underscores coming from partner dashboard
    'de-DE-informal': deInformal,
    'de-DE-formal': deFormal,
    'en-US': en,
    'en-GB': enGB,
    'en-CA': enCA,
    'fr-CA': frCA,
    'de-AT': deAT,
    // 'lb-LU': lbLU,
    'de-LU': deLU,
    'fr-LU': frLU,
    'en-DE': enDE,
    'de-CH': deCH,
}


export const i18n = new VueI18n({
    locale: 'de-DE-formal', // set locale
    messages: messages, // set locale messages
})

Vue.prototype.$t = function (key, options) {
    if (i18n.te(key + '_' + window.location.hostname)) {
        return i18n.t(key + '_' + window.location.hostname, options);
    }

    return i18n.t(key, options);
};

const loadedLanguages = ['de'] // our default language that is preloaded

function setI18nLanguage(lang) {
    i18n.locale = lang
    axios.defaults.headers.common['Accept-Language'] = lang
    document.querySelector('html').setAttribute('lang', lang)
    return lang
}

export function loadLanguageAsync(lang) {
    // If the same language
    if (i18n.locale === lang) {
        return Promise.resolve(setI18nLanguage(lang))
    }

    // If the language was already loaded
    if (loadedLanguages.includes(lang)) {
        return Promise.resolve(setI18nLanguage(lang))
    }

    // If the language hasn't been loaded yet
    return import(/* webpackChunkName: "lang-[request]" */ `./lang/${lang}.js`).then(
        messages => {
            i18n.setLocaleMessage(lang, messages.default)
            loadedLanguages.push(lang)
            return setI18nLanguage(lang)
        }
    )
}
